import { z } from 'zod';
import { eventSchema } from './envelope';

export const IMPORT_JOB_PREVIEWED_V1 = 'import.job.previewed.v1' as const;
export const IMPORT_JOB_COMPLETED_V1 = 'import.job.completed.v1' as const;
export const IMPORT_JOB_FAILED_V1 = 'import.job.failed.v1' as const;

const counts = {
  created: z.number().int(),
  updated: z.number().int(),
  deactivated: z.number().int(),
  skipped: z.number().int(),
  failed: z.number().int(),
};

export const jobPreviewedV1Schema = eventSchema({
  jobId: z.guid(),
  rowCount: z.number().int(),
  ...counts,
});

/**
 * Een afgeronde import. De tellingen staan in het event zelf, zodat het auditspoor
 * (Stap 18) en een latere melding aan HR (Stap 9) niet terug hoeven te rekenen.
 */
export const jobCompletedV1Schema = eventSchema({
  jobId: z.guid(),
  mode: z.enum(['changes_only', 'full_list']),
  rowCount: z.number().int(),
  ...counts,
});

export const jobFailedV1Schema = eventSchema({
  jobId: z.guid(),
  reason: z.string(),
});

export type JobPreviewedV1 = z.infer<typeof jobPreviewedV1Schema>;
export type JobCompletedV1 = z.infer<typeof jobCompletedV1Schema>;
export type JobFailedV1 = z.infer<typeof jobFailedV1Schema>;

export const importEventCatalog = {
  [IMPORT_JOB_PREVIEWED_V1]: jobPreviewedV1Schema,
  [IMPORT_JOB_COMPLETED_V1]: jobCompletedV1Schema,
  [IMPORT_JOB_FAILED_V1]: jobFailedV1Schema,
} as const;
